import { ActionButton, ActionsGroup } from '@elotech/components';
import React, { useState } from 'react';

import { Laudo } from '../../type';
import { CampoLocalizacao } from '../../utils/InscricaoCadastralUtils';
import { LotePropriedadeQuickView } from '../index';
import LaudoPropriedadeList from './LaudoPropriedadeList';

type Props = {
  propriedades: Laudo[];
  camposLocalizacao?: CampoLocalizacao[];
};

const LaudoPropriedadeResumo: React.FC<Props> = ({
  propriedades,
  camposLocalizacao
}) => {
  const [propriedadeQuickView, setPropriedadeQuickView] = useState<Laudo>();

  return (
    <>
      <LaudoPropriedadeList
        propriedades={propriedades}
        renderButton={item => (
          <ActionsGroup>
            <ActionButton
              key="view-button"
              icon="eye"
              label="Propriedades"
              onClick={() => setPropriedadeQuickView(item)}
            />
          </ActionsGroup>
        )}
      />
      <LotePropriedadeQuickView
        laudo={propriedadeQuickView}
        camposLocalizacao={camposLocalizacao}
        onClose={() => setPropriedadeQuickView(undefined)}
      />
    </>
  );
};

export default LaudoPropriedadeResumo;
